import { getAptGroupsAPI } from "@/apis/apt-groups-api"
import { aptSearchStore } from "./apt-search-store"
import { aptGroupStore } from "./_components/apt-group-store"
import { toast } from "sonner"

export const aptSelectLoader = async () => {
  await aptSearchStore.getState().apiGetAddrTree()

  try {
    const result = await getAptGroupsAPI()
    aptGroupStore.getState().setGroups(result)
  } catch {
    toast.error("그룹 목록을 불러오지 못했습니다.")
  }

  return null
}
